<fieldset class="fieldset"  *ngIf="paymentForm.controls">
<legend>פרטי תשלום חיצני בכרטיס אשראי</legend>
<div [formGroup]="paymentForm" style="margin: 0 auto;">
  <table class="table table-border">
    <thead class="text-nowrap">
      <th>תאריך ביצוע</th>
      <th>4 ספרות אחרונות</th>
      <th>מערכת סולקת</th>
    </thead>
    <tbody>
      <ng-container>
        <tr>
          <td>
            <date-input [withJewishDate]="false" [withLabel]="false" [placeholder]="'תאריך ביצוע:'"
              [dateControl]="paymentForm.controls.doneOn">Loading...</date-input>
          </td>
          <td>
            <input autocomplete="off" class="form-control"
            placeholder="4 ספרות אחרונות..." apply-enter
            formControlName="externalCcLast4Numbers" />
          </td>
          <td>
             <auto-complete-input apply-enter [withLabel]="false"  [placeholder]="'מערכת סולקת...'"
          [controllerName]="'ExternalCcClearingSystems'" [stringValueControl]="paymentForm.controls.externalCcClearingSystem"
          [formGroupModel]="paymentForm">
        </auto-complete-input>
            <!-- <input autocomplete="off" class="form-control"
            placeholder="מערכת סולקת..." apply-enter
            formControlName="externalCcClearingSystem" /> -->
          </td>
        </tr>

      </ng-container>
    </tbody>
  </table>
</div>
</fieldset>
